"use client"

import { OptimizedMediaType } from "@/app/types/media";
import { Box, colors, NoSsr } from "@mui/material";
import MediaV2 from "@v2/components/MediaV2";
import { useCallback, useState } from "react";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import PdpMobileFullscreenGallery from "./PdpMobileFullscreenGallery";


export default function PdpMobileGallery({ images, details }: {
    images: OptimizedMediaType[],
    details: {
        supersede_alt: string
    }
}) {
    const [fullScreenGalleryIsShow, setFullScreenGalleryIsShow] = useState<null | number>(null)

    const openFullscreenGallery = useCallback((index: number) => () => {
        setFullScreenGalleryIsShow(index)
    }, [])

    const img = images[0]

    return (
        <>
            {(fullScreenGalleryIsShow !== null) && (
                <PdpMobileFullscreenGallery
                    images={images}
                    show={fullScreenGalleryIsShow}
                    onClose={() => setFullScreenGalleryIsShow(null)}
                />
            )}
            <NoSsr fallback={
                img && (
                    <MediaV2
                        disablePlaceholder
                        media_id={img.id}
                        alt={img.alt ?? details.supersede_alt + " - عکس شماره 1"}
                        width={780}
                        height={482}
                        options={{
                            quality: 80
                        }}
                        boxProps={{
                            sx: {
                                width: '100%',
                                aspectRatio: '1.618 / 1',
                            }
                        }}
                        imageProps={{
                            fill: true,
                            priority: true,
                            fetchPriority: 'high',
                            style: {
                                objectFit: 'cover'
                            }
                        }}
                    />
                )
            }>
                <Box sx={{
                    position: 'relative',
                    '& .swiper-pagination': {
                        bottom: 16,
                        '& .swiper-pagination-bullet': {
                            borderRadius: 3,
                            transition: '150ms !important',
                            background: colors.grey[600],
                        },
                        '& .swiper-pagination-bullet-active': {
                            background: colors.grey[500],
                        }
                    }
                }}>
                    <Swiper
                        dir="rtl"
                        slidesPerView={1}
                        modules={[Pagination]}
                        style={{ height: '100%', width: '100%' }}
                        zoom={{
                            minRatio: 1,
                            maxRatio: 5,
                            toggle: true
                        }}
                        pagination={{
                            enabled: true,
                            dynamicBullets: true,
                            dynamicMainBullets: 3,
                        }}
                    >
                        {images?.map((img, index) => {
                            const hasPriority = index === 0;
                            return (
                                <SwiperSlide key={`${index}-${img.id}`} onClick={openFullscreenGallery(index)}>
                                    <MediaV2
                                        disablePlaceholder={hasPriority}
                                        media_id={img.id}
                                        alt={img.alt ?? details.supersede_alt + " - عکس شماره " + (index + 1)}
                                        width={780}
                                        height={482}
                                        boxProps={{
                                            sx: {
                                                width: '100%',
                                                aspectRatio: '1.618 / 1',
                                            }
                                        }}
                                        imageProps={{
                                            fill: true,
                                            priority: false,
                                            loading: 'lazy',
                                            style: {
                                                objectFit: 'cover'
                                            }
                                        }}
                                        options={{
                                            quality: 80
                                        }}
                                    />
                                </SwiperSlide>
                            )
                        })}
                    </Swiper>
                </Box>
            </NoSsr >
        </>

    )

}
